<template>
    <span
        class="inline-flex h-full w-1 cursor-default items-center justify-center px-2.5 text-xs font-black text-dark-500/20 dark:text-primary-50/30"
        >|</span
    >
</template>
